export default __webpack_public_path__ + "static/media/award-long.e4f6a570.png";